import React, {useState} from 'react';
import Header from "../common/Header/Header";
import '../../styles/index.scss'
import Menu from "../common/Menu/Menu";
import {useTheme} from "../../App";

const MainContainer = ({children, isDark, setTheme}) => {
  const [isMenu, setIsMenu] = useState(false)
  return (
    <div className={'mainWrapper'}>
      <Header openMenu={() => setIsMenu(true)} isDark={isDark} />
      <Menu closeMenu={() => setIsMenu(false)} isShow={isMenu} setTheme={setTheme} isDark={isDark} />
      <div className={"container minHeight"}>
        {children}
      </div>
    </div>
  );
};

export default React.memo(MainContainer);
